import BasketIcon from './BasketIcon'

export default BasketIcon
